import type { useFormatter } from 'next-intl';

const MINUTE = 60;
const MINUTES = MINUTE * 1000;
export const formatRelativeTime = (endTime: Date, relativeTime: ReturnType<typeof useFormatter>['relativeTime']) => {
  const diff = Math.max(endTime.getTime() - Date.now(), 0) / MINUTES;
  let type: 'minute' | 'hour' = 'minute';
  if (diff > MINUTE) {
    type = 'hour';
  }
  return relativeTime(diff !== 0 ? endTime : Date.now(), {
    unit: type,
    style: 'long',
    now: new Date(),
  });
};
